// react
import { Link } from 'react-router-dom';

// material-ui
import { AppBar, Button, Toolbar, Box } from '@mui/material';
import { LockPerson, PersonPin } from '@mui/icons-material';

// third-party

// asset
import siteLogo from 'assets/images/Cloud/logo.png';
import { baseColors, CLOUD_BASE_PATH } from 'utils/constants';
import useAuth from 'hooks/useAuth';

const Header = () => {
  const { isLoggedIn } = useAuth();

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: baseColors.white,
        position: { xs: 'sticky', sm: 'relative' },
        top: { xs: 0, sm: 'auto' },
        zIndex: 1000
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          margin: { xs: '0 auto', md: '10px auto' },
          width: { xs: '100%', sm: '1200px' },
          backgroundColor: baseColors.white
        }}
      >
        <Toolbar sx={{ justifyContent: 'center' }}>
          {/* ロゴ画像 */}
          <Box sx={{ flexGrow: 1 }}>
            <Link to={CLOUD_BASE_PATH}>
              <Box component="img" src={siteLogo} alt="logo" sx={{ width: { xs: '175px', md: '252px' } }} />
            </Link>
          </Box>
          <Button
            component={Link}
            to={isLoggedIn ? `${CLOUD_BASE_PATH}/mypage` : `${CLOUD_BASE_PATH}/login`}
            startIcon={isLoggedIn ? <PersonPin /> : <LockPerson />}
            sx={{
              color: baseColors.cloudOrange,
              '&:hover': {
                backgroundColor: baseColors.cloudLOrange
              }
            }}
          >
            {isLoggedIn ? 'マイページ' : 'ログイン'}
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
